import { useParams } from "react-router";

const useSupportUserTeamManagement = () => {
    const { id: ownerIdFromParams } = useParams<{ id: string }>();
    const ownerId = parseInt(ownerIdFromParams);

    return { ownerId };
};

export default useSupportUserTeamManagement;
